import React from "react";
import { Box, Text, Button, Tip, DataTable, Main, Layer } from "grommet";
import { CaretDownFill, CaretRightFill } from "grommet-icons";
import { BsChevronLeft, BsChevronRight, BsChevronUp } from "react-icons/bs";
import sortArray from "../../functions/sortArray";
import LoadingSign from "../../shared_comp/LoadingSign";
import { colorPaletteR, selectedInstsAnalysisR, selectedInstsNameAnalysisR } from "../../recoils/selectedInsts";
import { useRecoilState, useRecoilValue } from "recoil";
import useInst from "../../hooks/useInst";

const PageRedbookAnalysisTable = (props: any) => {
    let person_psnorders = props.psnorders;
    const [selectedInsts, setSelectedInsts] = useRecoilState(selectedInstsAnalysisR)
    const [selectedInstsName, setSelectedInstsName] = useRecoilState(selectedInstsNameAnalysisR)
    const colorInst = useRecoilValue(colorPaletteR)
    // console.log(colorInst)
    const [selectedPersonsMode, setSelectedPersonsMode] = React.useState(false);
    const [selectedPersons, setSelectedPersons] = React.useState<any[]>([]);

    let sort_direction = props.sort_direction;
    let sort_option = props.sort_option;
    let show_option = props.show_option;
    let main_insts_info = props.main_insts_info;
    let related_insts_info = props.related_insts_info;
    let other_insts_info = props.other_insts_info;
    // console.log("other_insts_info", other_insts_info)

    // console.log("PageRedbookAnalysisTable", props);
    const [getDataset, setGetDataset] = React.useState(false);

    const [colIndexStart, setColIndexStart] = React.useState(0);
    const [colIndexEnd, setColIndexEnd] = React.useState(0);
    const [colIndexRange, setColIndexRange] = React.useState(0);

    const [readyPersonPsnorderTable, setReadyPersonPsnorderTable] =
        React.useState(false);

    const [yrDist, setYrDist] = React.useState<any[]>([]);
    const [yrDistFull, setYrDistFull] = React.useState<any[]>([]);

    const [expandAll, setExpandAll] = React.useState(true);

    const [sortOptionKeep, setSortOptionKeep] = React.useState("-");

    const [filteredPersonPsnorders, setFilteredPersonPsnorders] =
        React.useState<any[]>([]);
    const [readyFilteredPersonPsnorders, setReadyFilteredPersonPsnorders] =
        React.useState(false);

    // read screen width
    const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);

    // detect change of screen width
    React.useEffect(() => {
        setReadyFilteredPersonPsnorders(false);
        setReadyPersonPsnorderTable(false);

        let yr_dist_full = [1908];
        for (let i = 0; i < 34; i++) {
            yr_dist_full.push(i + 1910);
        }
        yr_dist_full.push(1952);
        // console.log("RUE[] yr_dist_full", yr_dist_full)
        setYrDistFull(yr_dist_full);

        // console.log("RUE[] sort_option", sort_option)
        // setSortOptionKeep(sort_option);

        if (person_psnorders.length > 0) {
            setGetDataset(true);
        }
        // console.log("RUE[] person_psnorders", person_psnorders)
        setFilteredPersonPsnorders(person_psnorders);

        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        if (getDataset) {
            let n_col = Math.floor((screenWidth - 200) / 50);
            setColIndexRange(n_col);
            setColIndexStart(0);
            setColIndexEnd(n_col);
            // yrDist is first n_colth of yrDistFull
            let yr_dist = yrDistFull.slice(0, n_col);

            // console.log("RUE[screenWidth, getDataset] yr_dist", yr_dist)
            setYrDist(yr_dist);
        }
    }, [screenWidth, getDataset]);

    React.useEffect(() => {
        if(getDataset && sortOptionKeep !== sort_option) {
            setReadyPersonPsnorderTable(false);

            // console.log("RUE[sort_option, getDataset] received sort_option", sort_option)
            // console.log("RUE[sort_option, getDataset] sortOptionKeep", sortOptionKeep)

            setSortOptionKeep(sort_option);
            setFilteredPersonPsnorders(person_psnorders);
            // console.log("RUE[sort_option, getDataset] setFilteredPersonPsnorders", person_psnorders, filteredPersonPsnorders);

            setReadyPersonPsnorderTable(true)
            // console.log("RUE[sort_option, getDataset] setReadPersonPsnorderTable - true", readyPersonPsnorderTable);
        }
    }, [sort_option, getDataset]);

    const changeYearDistribution = () => {
        let n_col = Math.floor((screenWidth - 200) / 50);
        setColIndexRange(n_col);
        setColIndexStart(colIndexStart);
        setColIndexEnd(colIndexStart + n_col);
        // yrDist is first n_colth of yrDistFull
        let yr_dist = yrDistFull.slice(colIndexStart, colIndexStart + n_col);
        setYrDist(yr_dist);
    }

    React.useEffect(() => {
        if (readyPersonPsnorderTable) {
            changeYearDistribution()
        }
    }, [colIndexStart]);

    React.useEffect(()=>{
        // console.log("RUE[selectedInstsName] selectedInstsName", selectedInstsName)

    },[selectedInstsName])

    const rangeLeft = () => {
        setColIndexStart(colIndexStart - 1);
        setColIndexEnd(colIndexEnd - 1);
    };
    const ragneRight = () => {
        setColIndexStart(colIndexStart + 1);
        setColIndexEnd(colIndexEnd + 1);
    };
    const TableHeader = () => (
        <Box
            direction="row"
            align="center"
            border
            style={{ minHeight: "50px", maxHeight: "50px" }}
            pad={{bottom:'5px'}}
        >
            <Box
                width="35px"
                style={{ minWidth: "35px", maxWidth: "35px" }}
                background="lightgrey"
            />
            {/* PersonName Header */}
            <Box
                width="80px"
                align="center"
                justify="start" direction="row"
                style={{ minWidth: "80px", maxWidth: "80px" }}
            >
                <Button plain icon={expandAll ? (
                            <CaretDownFill size="20px" />
                        ) : (
                            <CaretRightFill size="20px" />
                        )}
                        onClick={() => setExpandAll(!expandAll)}
                />
                <Text size="10px">이름</Text>
            </Box>
            {/* ScrollLeft Header */}
            <Box
                width="35px"
                height="full"
                style={{ minWidth: "35px", maxWidth: "35px" }}
                align="center"
                justify="center"
            >
                <Button
                    plain
                    icon={<BsChevronLeft size="15px" color="black" />}
                    onClick={() => rangeLeft()}
                    disabled={colIndexStart === 0}
                />
            </Box>
            {/* PersonData Header*/}
            <Box direction="row" align="start" justify="center" width="full">
                {yrDist.map((y: any) => (
                    <Box
                        width="50px"
                        align="center"
                        justify="center"
                        style={{ minWidth: "50px" }}
                        key={y}
                    >
                        <Text size="10px">{y}</Text>
                    </Box>
                ))}
            </Box>
            {/* ScrollRight Header */}
            <Box
                width="35px"
                height="full"
                style={{ minWidth: "35px", maxWidth: "35px" }}
                align="center"
                justify="center"
            >
                <Button
                    plain
                    icon={<BsChevronRight size="15px" color="black" />}
                    onClick={() => ragneRight()}
                    disabled={colIndexEnd === yrDistFull.length}
                />
            </Box>
        </Box>
    );
    const LeftBorder = (props: any) => (
        <Box
            width="50px"
            direction="column"
            style={{ minWidth: "50px" }}
            border={
                props.left_border && {
                    side: "left",
                    color: "rgba(0,0,0,0.1)",
                    size: "1px",
                }
            }
        >
            {props.children}
        </Box>
    );
    const CellBase = (props: any) => (
        <Box
            align="center"
            justify="start"
            height="30px"
            width="full"
            style={{
                minHeight: "30px",
                maxHeight: "30px",
            }}
            hoverIndicator
        >
            {props.children}
        </Box>
    );
    const selectePerson=(person_data: any)=>{
        let person_id = person_data.person_id
        let person_id_index = selectedPersons.findIndex((p:any)=>p.person_id === person_id)
        if(person_id_index >= 0) {
            // already selected, remove from personsToEdit
            //console.log("already selected, remove from selectedPersons", person_data, selectedPersons)
            let new_selected_persons = [...selectedPersons]
            new_selected_persons.splice(person_id_index, 1)
            setSelectedPersons(new_selected_persons)
        } else {
            // not selected, add to personsToEdit
            //console.log("not selected, add to selectedPersons", person_data, selectedPersons)
            let new_selected_persons = [...selectedPersons]
            new_selected_persons.push(person_data)
            setSelectedPersons(new_selected_persons)
        }
    }

    const PersonRow = (props: any) => {
        let person_data = props.person_data;
        // for row_number specify PersonPsnorders
        let target_person_psnorders = filteredPersonPsnorders;
        if(props.call === "selected") { target_person_psnorders = selectedPersons }

        let row_number = target_person_psnorders.findIndex(
            (p: any) => p.person_id === person_data.person_id
        );
        const [expand, setExpand] = React.useState(expandAll);
        const [selected, setSelected] = React.useState(false);

        React.useEffect(()=>{
            // console.log("RUE[selectedInstsName] selectedInstsName", selectedInstsName)
            let psnorders_person_row = person_data.psnorders;
            for(let i=0; i<psnorders_person_row.length; i++){
                let year_data_row = psnorders_person_row[i].person_year_data;
                let found = false
                for (let j=0; j<year_data_row.length; j++){
                    let inst_name = year_data_row[j].psnorder.status_text;
                    if (selectedInstsName.includes(inst_name)) {
                        found = true
                        setSelected(true)
                        // console.log("RUE[selectedInstsName] selectedInstsName", selectedInstsName, inst_name, selected)
                        break;
                    }
                }
                if(found) break;
            }
        },[selectedInstsName])

        const PersonName = (props: any) => (
            <Box
                width="80px"
                direction="row"
                style={{ minWidth: "80px", maxWidth: "80px" }}
                align="start"
                justify="start"
            >
                <Button
                    disabled={props.call === "selected"? true: false}
                    plain
                    onClick={() => setExpand(!expand)}
                    icon={
                        expand ? (
                            <CaretDownFill size="15px" />
                        ) : (
                            <CaretRightFill size="15px" />
                        )
                    }
                />
                <Button plain onClick={()=>selectePerson(props.data)}
                label={
                    <Text size="13px" weight={selectedPersons.map((p:any)=>p.person_id).includes(props.data.person_id)? "bold": "normal"}
                        color={selectedPersons.map((p:any)=>p.person_id).includes(props.data.person_id)? "indigo": "black"}>
                            {props.name}
                    </Text>}/>

            </Box>
        );
        const [otherInstsInfo, setOtherInstsInfo] = React.useState<any[]>([]);

        const PersonData = (props: any) => {
            let person_data = props.person_data;
            let person_psnorders = person_data.psnorders;
            // console.log("person_data.pasnorders", person_data.psnorders)


            const APsnorder = (props: any) => {
                let a_psnorder_data = props.psnorder;
                // console.log("a_psnorder_data", a_psnorder_data)
                // if inst_group is main, border color is red
                // if inst_group is related, border color is orange
                let border_color =
                    a_psnorder_data.inst_group === "main" ? "red" : "orange";
                border_color =
                    a_psnorder_data.inst_group === "other"
                        ? "grey"
                        : border_color;
                let background_color =
                    a_psnorder_data.inst_group === "main"
                        ? "rgba(255,0,0,0.1)"
                        : "rgba(255,165,0,0.1)";
                background_color =
                    a_psnorder_data.inst_group === "other"
                        ? "rgba(0,0,0,0.1)"
                        : background_color;
                // text show option
                let text = "-";
                if (show_option === "position") {
                    text = a_psnorder_data.psnorder.status_pos;
                } else if (show_option === "grade") {
                    text = a_psnorder_data.psnorder.status_grade;
                } else if (show_option === "merit") {
                    text = a_psnorder_data.psnorder.status_merit;
                }
                if (text === undefined || text === " ") text = "-";

                // check apsnorder in selected inst
                let selected = false;
                let inst_name = a_psnorder_data.psnorder.status_text;
                let inst_name_index = selectedInstsName.findIndex(
                    (i: any) => i === inst_name
                );
                if (inst_name_index >= 0) {
                    selected = true;
                }
                const addInstToSelected=()=>{
                    let inst_group = a_psnorder_data.inst_group
                    let inst_info: any = {}
                    const getInstByNameExact = async (inst_name: string) => {
                        let res_inst = await useInst.getInstByNameExact(inst_name);
                        if(res_inst){return res_inst}
                        else {return null}
                    };
                    const updateSelectedInsts = (inst_info: any) => {
                        let new_selected_insts = [...selectedInsts];
                        new_selected_insts.push(inst_info.inst);
                        setSelectedInsts(new_selected_insts);

                        let new_selected_insts_name = [...selectedInstsName];
                        new_selected_insts_name.push(inst_name);
                        setSelectedInstsName(new_selected_insts_name);
                        selected = true;
                    }
                    if(inst_group === "other") {
                        // check not inst_id, find inst_info in other_insts_info
                        inst_info = other_insts_info.find((i: any)=>i.inst.primaryname===inst_name)
                        if(inst_info.inst.inst_id === null) {
                            getInstByNameExact(inst_name).then((res_inst: any) => {
                                // console.log("getInstByNameExact", res_inst, inst_info.inst.primaryname)
                                if(res_inst){
                                    let new_selectedInst = {
                                        inst_id: res_inst.inst.inst_id,
                                        primaryname: res_inst.inst.primaryname,
                                        primaryname_ko: res_inst.inst.primaryname_ko,
                                        inst_type: res_inst.inst.inst_type,
                                        inst_category: res_inst.inst.inst_category,
                                    }
                                    // find in selectedInsts with inst_name
                                    // replace otherInstsInfo with res_inst
                                    let index2 = otherInstsInfo.findIndex((p:any) => p.inst.primaryname === inst_info.inst.primaryname)
                                    let otherInstsInfo_copy = [...otherInstsInfo]
                                    otherInstsInfo_copy[index2] = res_inst
                                    setOtherInstsInfo(otherInstsInfo_copy)
                                    updateSelectedInsts(res_inst)
                                }
                            })
                        }
                    } else if(inst_group === "main") {
                        // already has inst_id, find inst_info in main_insts_info
                        inst_info = main_insts_info.find((i: any)=>i.inst.primaryname===inst_name)
                        updateSelectedInsts(inst_info)
                    } else if(inst_group === "related") {
                        // already has inst_id, find inst_info
                        inst_info = related_insts_info.find((i: any)=>i.inst.primaryname===inst_name)
                        updateSelectedInsts(inst_info)
                    }
                }
                const removeInstFromSelected=()=>{
                    let new_selected_insts = [...selectedInsts]
                    let index = new_selected_insts.findIndex((i:any)=>i.primaryname===inst_name)
                    new_selected_insts.splice(index, 1)
                    setSelectedInsts(new_selected_insts)
                    let new_selected_insts_name = [...selectedInstsName]
                    let index_name = new_selected_insts_name.findIndex((i:any)=>i===inst_name)
                    new_selected_insts_name.splice(index_name, 1)
                    setSelectedInstsName(new_selected_insts_name)
                    selected = false
                }

                const TipTextBox = (props: any) => {
                    let pos = props.status_pos;
                    let grade = props.status_grade;
                    let merit = props.status_merit;
                    let memo = props.status_memo;
                    let inst = props.inst;
                    let name = props.person_name;
                    return (
                        <Box
                            background={selected? "white": "rgba(255,255,255,0.9)"}
                            direction="column"
                            align="center"
                            justify="center"
                            pad="10px"
                            border={selected? {color: colorInst[inst_name_index], size: "2px"}: undefined}
                        >
                            {inst && <Text size="12px">{inst}</Text>}
                            {(pos || name) && (
                                <Text size="12px">
                                    {pos && (
                                        <Text size="10px">
                                            {pos}
                                            {"  "}
                                        </Text>
                                    )}
                                    {name && <Text size="12px" weight="bold">{name}</Text>}
                                </Text>
                            )}
                            {(grade || merit) && (
                                <Text size="12px">
                                    {grade && (
                                        <Text size="11px">
                                            {grade}
                                            {"  "}{" "}
                                        </Text>
                                    )}
                                    {merit && <Text size="11px">{merit}</Text>}
                                </Text>
                            )}
                            {memo && <Text size="10px">비고: {memo}</Text>}
                        </Box>
                    );
                };

                return (
                    <Tip
                        plain
                        content={
                            <TipTextBox
                                status_pos={a_psnorder_data.psnorder.status_pos}
                                status_grade={
                                    a_psnorder_data.psnorder.status_grade
                                }
                                status_merit={
                                    a_psnorder_data.psnorder.status_merit
                                }
                                status_memo={
                                    a_psnorder_data.psnorder.status_memo
                                }
                                inst={a_psnorder_data.psnorder.status_text}
                                person_name={
                                    a_psnorder_data.psnorder.personname
                                }
                            />
                        }
                    >
                        <Box
                            border={selected? {color: colorInst[inst_name_index], size: "2px"}: {
                                color: border_color,
                                side: "top",
                                size: "2px",
                            }}
                            align="center"
                            justify="center"
                            height="20px"
                            width="full"
                            background={selected? "white": background_color}
                            onClick={()=>{
                                selected? removeInstFromSelected(): addInstToSelected()
                            }}
                        >
                            {/* show text length 5 under, if the length is greater than 5, add ... */}
                            <Text size="10px">
                                {text.length > 4
                                    ? text.slice(0, 4) + "..."
                                    : text}
                            </Text>
                        </Box>
                    </Tip>
                );
            };
            const PersonYear = (props: any) => {
                let year = props.year;
                // // test
                // if(yrDist[yrDist.length-1] === year) {
                //     console.log("last year show", year)
                // }
                // check if person_psnorders has year
                let left_border = false;
                let years_left_border = [1910, 1920, 1930, 1940, 1952]
                if (years_left_border.includes(year)) {left_border = true }
                let person_year_index = person_psnorders.findIndex(
                    (p: any) => p.year === year
                );

                if (person_year_index < 0) {
                    return (
                        <Box
                            width="50px"
                            style={{ minWidth: "50px" }}
                            height="full"
                            border={
                                left_border && {
                                    side: "left",
                                    color: "rgba(0,0,0,0.1)",
                                    size: "1px",
                                }
                            }
                        >
                            <Text size="5px"></Text>
                        </Box>
                    );
                } else {
                    let person_year_data =
                        person_psnorders[person_year_index].person_year_data;
                    return (
                        <>
                            {expand ? (
                                <LeftBorder left_border={left_border}>
                                    {person_year_data.map((p: any, index:any) => (
                                        <APsnorder
                                            psnorder={p}
                                            key={p.psnorder.psnorder_id}
                                        />
                                    ))}
                                    <CellBase>
                                        <Button
                                            size="xsmall"
                                            plain
                                            onClick={() => setExpand(false)}
                                            label={person_year_data.length>1?
                                            <BsChevronUp size='8px'/>:
                                            <Text size='8px'>{"    "}</Text>}
                                        />
                                    </CellBase>
                                </LeftBorder>
                            ) : (
                                <LeftBorder left_border={left_border}>
                                    <APsnorder psnorder={person_year_data[0]} />
                                    <CellBase>
                                        {person_year_data.length > 1 ? (
                                            <Button
                                                size="xsmall"
                                                plain
                                                onClick={() => setExpand(true)}
                                                label={
                                                    <Text size="8px">
                                                        {" "}
                                                        {
                                                            person_year_data.length
                                                        }
                                                    </Text>
                                                }
                                            />
                                        ) : (
                                            <Button
                                                plain
                                                size="xsmall"
                                                disabled
                                            />
                                        )}
                                    </CellBase>
                                </LeftBorder>
                            )}
                        </>
                    );
                }
            };
            return (
                // background color is light grey if row number even
                <Box
                    direction="row"
                    align="start"
                    justify="center"
                    width="full"
                >
                    {yrDist.map((y: any) => (
                        <PersonYear year={y} key={y} />
                    ))}
                </Box>
            );
        };
        return (
            <Box
                flex={false}
                direction="row"
                background={
                    selected? "rgba(255,204,0, 0.1)":(row_number % 2 === 0 ? "rgba(245,245,245)" : "white")
                }
                style={{ minHeight: "55px" }}
            >
                {/* SelectArea */}
                <Box
                    width="35px"
                    style={{ minWidth: "35px", maxWidth: "35px" }}
                />
                {/* PersonName */}
                <PersonName name={person_data.person_name} data={person_data}/>
                {/* ScrollLeft */}
                <Box
                    width="35px"
                    style={{ minWidth: "35px", maxWidth: "35px" }}

                    focusIndicator={false}
                    onClick={() => {
                        colIndexStart !== 0 && rangeLeft();
                    }}
                />
                {/* PersonData */}
                <PersonData person_data={person_data} />
                {/* ScrollRight */}
                <Box
                    width="35px"
                    style={{ minWidth: "35px", maxWidth: "35px" }}

                    focusIndicator={false}
                    onClick={() => {
                        colIndexEnd !== yrDistFull.length && ragneRight();
                    }}
                />
            </Box>
        );
    };
    const mergeSelectedPersonsNotice=()=>{
        setSelectedPersonsMode(true)
    }

    const mergeSelectedPersons = () => {
        //console.log("mergeSelectedPersons", selectedPersons)
        let new_person_data = selectedPersons[0]
        // person_id_new
        let person_id_new = selectedPersons.map((p:any)=>p.person_id_new).join(";")
        let person_name = selectedPersons.map((p:any)=>p.person_name).join(";")
        // min start_year
        let start_year = selectedPersons.map((p:any)=>p.start_year).reduce((a:any, b:any)=>Math.min(a, b))
        // max end_year
        let end_year = selectedPersons.map((p:any)=>p.end_year).reduce((a:any, b:any)=>Math.max(a, b))
        // min main_start_year
        let main_start_year = selectedPersons.map((p:any)=>p.main_start_year).reduce((a:any, b:any)=>Math.min(a, b))
        // max main_end_year
        let main_end_year = selectedPersons.map((p:any)=>p.main_end_year).reduce((a:any, b:any)=>Math.max(a, b))
        // aggregate person_year_data of psnorders of selectedPersons
        let agg_psnorders = []
        for(let i=0; i<selectedPersons.length; i++){
            let person_year_data = selectedPersons[i].psnorders.map((p:any)=>p.person_year_data)
            for(let j=0; j<person_year_data.length; j++){
                agg_psnorders.push(...person_year_data[j])
            }
        }
        //console.log("mergeSelectedPersons", agg_psnorders)
        // regroup agg_person_year_data by year
        // sort each year data by inst_group (main, related, other)
        let agg_person_year_data_by_year:any = []
        let agg_person_year_data_by_year_index:any = []
        for(let i=0; i<agg_psnorders.length; i++){
            let year = agg_psnorders[i].year
            let index = agg_person_year_data_by_year_index.findIndex((y:any)=>y===year)
            if(index >= 0){
                agg_person_year_data_by_year[index].push(agg_psnorders[i])
                // sort by inst_group (main, related, other)
                agg_person_year_data_by_year[index].sort((a:any, b:any)=>{
                    let a_group = a.inst_group
                    let b_group = b.inst_group
                    if(a_group === "main") return -1
                    else if(b_group === "main") return 1
                    else if(a_group === "related") return -1
                    else if(b_group === "related") return 1
                    else return 0
                })
            } else {
                agg_person_year_data_by_year_index.push(year)
                agg_person_year_data_by_year.push([agg_psnorders[i]])
            }
        }
        //console.log("mergeSelectedPersons", agg_person_year_data_by_year)
        let new_person_psnorders:any = []
        agg_person_year_data_by_year.forEach((y:any)=>{
            let psnorder_year = {
                person_id:new_person_data.person_id,
                person_name:new_person_data.person_name,
                year: y[0].year,
                person_year_data: y
            }
            new_person_psnorders.push(psnorder_year)
        })
        new_person_data.person_id_new = person_id_new
        new_person_data.person_name = person_name
        new_person_data.start_year = start_year
        new_person_data.end_year = end_year
        new_person_data.main_start_year = main_start_year
        new_person_data.main_end_year = main_end_year
        new_person_data.psnorders = new_person_psnorders
        //console.log("mergeSelectedPersons", new_person_data)
        // remove selectedPersons from filteredPersonPsnorders
        let new_filteredPersonPsnorders = [...filteredPersonPsnorders]
        for(let i=0; i<selectedPersons.length; i++){
            let person_id = selectedPersons[i].person_id
            let index = new_filteredPersonPsnorders.findIndex((p:any)=>p.person_id === person_id)
            new_filteredPersonPsnorders.splice(index, 1)
        }
        // sort new_filteredPersonPsnorders by person_name
        new_filteredPersonPsnorders.push(new_person_data)
        // update filteredPersonPsnorders
        new_filteredPersonPsnorders.sort((a:any, b:any)=>{
            let a_name = a.person_name
            let b_name = b.person_name
            if(a_name < b_name) return -1
            else if(a_name > b_name) return 1
            else return 0
        })
        setFilteredPersonPsnorders(new_filteredPersonPsnorders)
        // update selectedPersons
        setSelectedPersons([])
        setSelectedPersonsMode(false)
    }
    const SelectedPersonsBox = (props:any) => {
        return (
            <>
                <Box
                    width="full"
                    direction="column"
                    border={{ color: "indigo", size: "2px" }}
                    flex={false}
                >
                    {selectedPersons.map((p: any) => (
                        <PersonRow
                            person_data={p}
                            key={p.person_id_new}
                            call={"selected"}
                        />
                    ))}
                </Box>
                <Box alignSelf="start" margin={{ bottom: "10px" }}>
                    <Button
                        plain
                        disabled={selectedPersons.length < 2 ? true : false}
                        label={
                            <Box
                                direction="row"
                                align="center"
                                justify="center"
                                margin="10px"
                            >
                                <Text size="12px" color="indigo" weight="bold">
                                    선택한 인물 합쳐서 보기
                                </Text>
                            </Box>
                        }
                        hoverIndicator
                        onClick={() => mergeSelectedPersonsNotice()}
                    />
                </Box>
                {selectedPersonsMode && (
                    <Layer
                        modal
                        position="center"
                        onClickOutside={() => setSelectedPersonsMode(false)}
                        onEsc={() => setSelectedPersonsMode(false)}
                    >
                        <Box
                            width="medium"
                            height="medium"
                            background="white"
                            align="center"
                            justify="center"
                            pad="medium"
                            gap="medium"
                            round="small"
                            elevation="medium"
                        >
                            <Text size="13px">
                                아래 텍스트를 복사하여 관리자에게 보내시면, 향후
                                검색에서 선택인물이 통합되어 보여집니다.
                            </Text>
                            <Text size="13px">
                                메모장에 복사하여 수정사항을 모은 후, 연구센터
                                텔레그램 등의 메신저로 보내세요.
                            </Text>
                            <Box
                                width="full"
                                height="small"
                                background="lightgrey"
                                align="center"
                                justify="center"
                                pad="medium"
                                gap="medium"
                                round="small"
                                elevation="medium"
                            >
                                <Text size="13px" weight="bold">
                                    #KNUE_REDBOOK_PERSON_MERGE#
                                    {new Date().toLocaleString("ko-KR")}
                                    #P
                                    {selectedPersons
                                        .map((p: any) => p.person_id_new)
                                        .join(";")}
                                    #end#
                                </Text>
                            </Box>
                            <Box
                                direction="row"
                                align="center"
                                justify="center"
                                gap="medium"
                            >
                                <Button
                                    plain
                                    label={
                                        <Box
                                            align="center"
                                            justify="center"
                                            pad="10px"
                                        >
                                            <Text size="13px">취소</Text>
                                        </Box>
                                    }
                                    onClick={() =>
                                        setSelectedPersonsMode(false)
                                    }
                                />
                                <Button
                                    plain
                                    label={
                                        <Box
                                            align="center"
                                            justify="center"
                                            pad="10px"
                                        >
                                            <Text size="13px">합쳐서 보기</Text>
                                        </Box>
                                    }
                                    onClick={() => mergeSelectedPersons()}
                                />
                            </Box>
                        </Box>
                    </Layer>
                )}
            </>
        );
    }

    return (
        <Box height="full" direction="column">
            <Box
                margin={{ top: "20px" }}
                width="full"
                direction="column"
                align="center"
                overflow={"horizontal"}
            >
                <Box
                    height="full"
                    width="full"
                    overflow={"horizontal"}
                    direction="column"
                    flex={false}
                >
                    <TableHeader />
                </Box>
            </Box>
            {selectedPersons.length > 0 && <SelectedPersonsBox/>}
            {readyPersonPsnorderTable ? (
                <Box
                    width="full"
                    overflow={"auto"}
                    direction="column"
                    height="full"
                    border
                >
                    {filteredPersonPsnorders.map((p: any) => (
                        <PersonRow
                            person_data={p}
                            key={p.person_id_new}
                            call={"filtered"}
                        />
                    ))}
                </Box>
            ) : (
                <LoadingSign />
            )}
        </Box>
    );
};

export default PageRedbookAnalysisTable;
